import React from 'react';
import { Flex, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { CustomButton, CustomTitle } from '../../components';
import EmptyShipmentBg from '../../assets/images/empty-shipment-bg.svg';
import EmptyShipmentBox from '../../assets/images/empty-shipment-box.svg';
import theme from '@/assets/theme';
import { LinkInlineIcon } from '../../assets/icons/icons';
import styles from './EmptyShipments.module.css';
interface EmptyShipmentsProps {
  handleConnectButtonClick: () => void;
  handleShipmentFormModal: () => void;
  allPermissions?: {
    is_create?: boolean;
  };
  isLoading?: boolean;
  showTrackManually?: boolean;
}

/**
 * Empty state component displayed when no shipments are being tracked
 *
 * @param handleConnectButtonClick - Callback for connecting transport providers
 * @param handleShipmentFormModal - Callback for manual shipment tracking
 * @param allPermissions - User permissions object
 */
const EmptyShipments: React.FC<EmptyShipmentsProps> = ({
  handleConnectButtonClick,
  handleShipmentFormModal,
  allPermissions,
  isLoading,
  showTrackManually = true,
}) => {
  return (
    <Flex justify='center' align='flex-start'>
      {isLoading && (
        <div className='spinner-overlay'>
          <Spin size='large' />
        </div>
      )}

      <Flex gap={12} vertical={true} className={styles.container}>
        <div className={styles.iconWrap}>
          <div
            className={styles.bg}
            // eslint-disable-next-line react/forbid-dom-props -- the background is a bundled asset URL, only known at runtime
            style={{ backgroundImage: `url(${EmptyShipmentBg})` }}
          >
            <img src={EmptyShipmentBox} alt='' className={styles.box} />
          </div>
        </div>

        <CustomTitle
          text={
            isLoading
              ? 'Shipments loading...'
              : "You're not tracking any shipments yet"
          }
          fontSize={24}
          fontWeight={700}
          lineHeight={'32px'}
          color={'var(--text-primary)'}
          marginTop={'12px'}
          marginBottom={0}
        />
        {!isLoading && (
          <CustomTitle
            text={`To start tracking your shipments, connect your ${theme?.themeType === 2 ? 'carriers' : 'transport providers'} , or manually enter your shipment tracking IDs.`}
            fontSize={14}
            fontWeight={400}
            lineHeight={'20px'}
            color={'var(--text-secondary)'}
            marginBottom={0}
            marginTop={0}
          />
        )}
        {!isLoading && (
          <Flex wrap gap={8} align='center' justify='center'>
            {allPermissions?.is_create && (
              <CustomButton
                onClick={handleConnectButtonClick}
                height='48px'
                minWidth='204px'
                fontSize='14px'
                text={`Connect  ${theme?.themeType === 2 ? 'carriers' : 'providers'}`}
                bgColor='var(--light-gray)'
                borderRadius='40px'
                color='var(--text-primary)'
                boxShadow='none'
                iconPosition='left'
                icon={<LinkInlineIcon />}
                gap='10px'
                lineHeight={'20px'}
                fontWeight={600}
              />
            )}
            {allPermissions?.is_create && showTrackManually && (
              <CustomButton
                onClick={handleShipmentFormModal}
                height='48px'
                minWidth='178px'
                fontSize='14px'
                text={'Track manually'}
                bgColor='var(--light-gray)'
                borderRadius='40px'
                color='var(--text-primary)'
                boxShadow='none'
                iconPosition='left'
                icon={<PlusOutlined />}
                gap='10px'
                lineHeight={'20px'}
                fontWeight={600}
              />
            )}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default EmptyShipments;
